export default __webpack_public_path__ + "static/media/Ratechart.41067621.csv";